import http from "./http";

//获取推送列表
export const getPushList = async (data) => {
    return await http.get(`/appServices/getAppServiceList`, data);
};
//获取推送详情
export const getPushDetail = async (data) => {
    return await http.get(`/appServices/getAppService`, data);
};
//更新推送
export const updatePush = async (data) => {
    return await http.post(`/appServices/updateAppService`, data);
};
//更新推送
export const deletePush = async (data) => {
    return await http.post(`/appServices/markDeleteAppService`, data);
};
